import BernhardBefore from "../Images/Bernhard1.jpg"
import BernhardAfter from "../Images/Bernhard2.jpg"
import SebastianBefore from "../Images/Sebastian1.jpg"
import SebastianAfter from "../Images/Sebastian2.jpg"
import Before from "../Images/Before.png"
import After from "../Images/After.png"
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswerOutlined"
import ClassIcon from "@mui/icons-material/ClassOutlined"
import FitnessCenterIcon from "@mui/icons-material/FitnessCenterOutlined"
import AssignmentIcon from "@mui/icons-material/AssignmentOutlined"
import {LoginSharp} from "@mui/icons-material";
import React from "react";

export const contentTexts = {
    topTitlePageSlogan: "Dein Erfolg",
    bottomTitlePageSlogan: "Mein Fokus",
    subtitleTitlePageSlogan: "Online Fitness Coaching, das sich auszahlt.",
    titlePageButton: "Jetzt Termin vereinbaren",


    aboutMeContent: [
        "Klassisches Personal Training war gestern - heute trainieren wir selbstbestimmt, flexibel und digital!",
        "Hi, ich bin Christof, Physiotherapeut & Personal Trainer - und habe ein Online-Konzept entwickelt, das individuelles Training neu denkt!",
        "Unser Leben wird immer digitaler, jetzt zieht auch die Trainingswelt nach und verabschiedet das klassische Personal Training. Nervige Terminvereinbarungen, starrende Trainerblicke und unselbstständiges Training gehören somit der Vergangenheit an!",
        "Von mir erfährst du aufgrund von wissenschaftlichen Ansätzen, theoretischen Erklärungsmodellen, sowie der Erfahrung aus der Praxis, wie sich ein sinnvoller und realisierbarer Trainingsplan gestalten lässt, sodass Bro-Science und Fitness-Mythen keine Chance haben."
    ],
    aboutMeTitle: "Über mich",
    aboutMeSubtitle: "Mein Fokus",

    customerTitle: "Reviews",
    customerSubtitle: "Eure Erfolge",

    customerReviews: [
        {
            title: "Bernhard, 25",
            subtitle: ["3 Sessions pro Woche", "6 Monate Coaching"],
            description: "Ich habe mit YouTube-Homeworkouts begonnen, doch dank Christof bemerkt, wie viel effektiver das Training im Fitnessstudio sein kann. Er hat mir die richtigen Übungen gezeigt und gab mir auch aus der Ferne wertvolle Tipps. In kurzer Zeit machte ich enorme Fortschritte und schätzte, dass der Trainingsplan individuell auf meinen Lebensstil angepasst wurde. Durch mein Feedback wurde der Plan perfekt optimiert und der Gang ins Fitnessstudio zu einer unverzichtbaren Routine.",
            before: BernhardBefore,
            after: BernhardAfter
        },
        {
            title: "Sebastian, 23",
            subtitle: ["3 Sessions pro Woche", "3 Monate Coaching"],
            description: "Ich habe das Training unter Christof sehr genossen. Auf Fragen hat er immer schnell geantwortet und ist auch immer auf meine Wünsche eingegangen, wenn ich zum Beispiel etwas im Trainingsplan ändern wollte. Das Feedback zu den von mir gesendeten Videos war immer kurz und knackig auf den Punkt gebracht und hat mir stets viel geholfen.",
            before: SebastianBefore,
            after: SebastianAfter
        },
        {
            title: "Nadja, 23",
            subtitle: ["2 Sessions pro Woche", "3 Monate Coaching"],
            description: "Das Coaching hat mir wirklich gut gefallen, vor allem, weil Christof sich die Mühe gemacht hat, alternative Übungen anzubieten, wenn etwas gerade nicht gepasst hat. Besonders geschätzt habe ich, dass alles einfach und verständlich gehalten wurde. Ich kann ehrlich sagen, dass ich krafttechnisch deutlich weitergekommen bin und jetzt sogar einige meiner körperlichen Ziele erreicht habe. Insgesamt hat mir das Programm wirklich Spaß gemacht und mir gezeigt, dass es vor allem auf die Regelmäßigkeit ankommt. Ich habe gelernt, dass ich nicht jeden Tag trainieren muss, um meine Ziele zu erreichen. Die Fortschritte, die ich gemacht habe, bestätigen das.",
            before: Before,
            after: After
        },
        {
            title: "Patrick, 25",
            subtitle: ["2 Sessions pro Woche", " 3 Monate Coaching"],
            description: "Ich bin super zufrieden mit dem Coaching, da ich davor immer nur sporadisch trainierte und dank Christof es geschafft habe, mein Training durchzuziehen. Zudem, dass es mir Spaß gemacht hat, bekam ich auch wertvolle Tipps für die Übungen, die ich sofort anwenden konnte und instant die Verbesserung merkte.",
            before: Before,
            after: After
        },
        {
            title: "Wolfgang, 24",
            subtitle: ["2 Sessions pro Woche", "3 Monate Coaching"],
            description: "Ich find das Coaching war echt mega gut, vor allem, weil ich halt noch nie im Gym war und dadurch anfangs auch echt unsicher war bzw. meine Motivation sich sehr Grenzen gehalten hat. Aber Christof hat mir da echt einen guten Plan zusammengestellt und ist auch toll auf meine Fragen eingegangen bzw. hat die Übungen dann auch gut erklärt, sprich was ich besser machen kann bzw. auf was ich achten soll. Dadurch habe ich mich gleich viel sicherer gefühlt und er hat mich auch mega gut gepusht, sodass ich mittlerweile echt gern ins Gym geh und das Trainieren auch echt Spaß macht.",
            before: Before,
            after: After
        },
    ],

    coachingTitle: "The Smart Physique Plan",
    coachingSubtitle: "Das erwartet dich",

    coachingContent: [
        {
            header: "Trainingsplan & Optimierung",
            subtitle: [
                "Individuelle Erstellung deines Trainingsplans",
                "Wöchentliche personalisierte Anpassung je nach Fortschritt",
                "Sportartspezifische Ausrichtung deines Trainings (z.B. Laufen, Klettern, Teamsport)",
            ],
            icon: (<AssignmentIcon sx={{height: "40px", width: "40px"}}/>)
        }, {
            header: "Analyse & Feedback",
            subtitle: [
                "Detaillierte Videoanalyse deiner Übungsausführung",
                "Wöchentliches Feedback über strukturierte Checkins",
                "Laufende Analyse deiner Trainingsdaten und -parameter",
            ],
            icon: (<ClassIcon sx={{height: "40px", width: "40px"}}/>)
        }, {
            header: "Tracking & Betreuung",
            subtitle: [
                "Wöchentliche Dokumentation und Anpassung deiner Trainingsvariablen",
                "Direkter Support bei allen trainingsrelevanten Fragen (z.B. Technik, Belastung, Planung)",
            ],
            icon: (<QuestionAnswerIcon sx={{height: "40px", width: "40px"}}/>)
        }, {
            header: "Ressourcen & Unterlagen",
            subtitle: [
                "Kompakte Lehrvideos für ein besseres Trainingsverständnis",
                "Über 75 Übungsvideos mit Voice-Overs, Untertiteln und visuellen Markierungen",
            ],
            icon: (<FitnessCenterIcon sx={{height: "40px", width: "40px"}}/>)
        }
    ],

    digitalHubTitle: "The Smart Physique Plan",
    digitalHubSubtitle: "Digital Hub",

    costPageTitle: "The Smart Physique Plan",
    costPageSubtitle: "Keine versteckten Kosten",

    contentTextCostPage: ["Das Coaching ist ein All-Inclusive Angebot mit allen zuvor angeführten Leistungen, es fallen keine zusätzlichen Kosten an!",
        "Mir ist Transparenz sehr wichtig, weshalb ich dir hier schon sagen will, was das Coaching kostet und dich nicht erst in unserem kostenlosen Kennenlernmeeting damit überrumpeln.",
        "Das Coaching kann monatlich gekündigt, sowie einmalig für einen Monat pausiert werden."],

    costTextCostPage: "Der reguläre Preis für The Smart Physique Plan lag bei 500€ pro Monat. Aktuell profitieren Neukunden jedoch von einem Sonderrabatt und zahlen lediglich:",
    costNewCustomer: "349€",
    costNewCustomerReal: "500€",



    coachingAppointmentTitle: "Termin vereinbaren",
    coachingAppointmentSubtitle: "Kostenloses Erstgespräch",
    coachingAppointmentContent: "Bevor wir uns Kopfüber ins Coaching stürzen, ist es mir wichtig ein kostenloses unverbindliches Erstgespräch zu führen und alle Fragen zu klären, welche sich bei dir aufgetan haben! Nach diesem Meeting können wir beide gemeinsam entscheiden, ob es für uns passt und ein Coaching sinnvoll ist.",

    singleActionsContent: [
        {
            id: "trainplan",
            title: "Trainingsplan + Adaptierung",
            price: 119,
            content: [
                "Ich erstelle dir einen individuellen Trainingsplan nach deinen Wünschen und Ansprüchen. Dann hast du 4 Wochen Zeit deinen Plan zu testen, bevor du die Möglichkeit bekommst, mir Feedback zu geben, was du an deinem Training magst und was nicht. Aufgrund dieser Information passe ich dir deinen Plan nochmals an, sodass du einen nachhaltigen und langfristigen Trainingserfolg hast!",
                "Einzelleistungen sind ab Kaufdatum 2 Jahre gültig."
            ]
        },
        {
            id: "checkup",
            title: "Trainingsplan Checkup",
            price: 99,
            content: [
                "Du hast bereits einen Trainingsplan und willst ihn optimieren oder nach deinen sportartspezifischen Anforderungen anpassen? Dann ist dieses Checkup genau richtig für dich! Gemeinsam schrauben wir an deinem Plan und verändern ihn so, dass er eine optimale Performance und Integrierbarkeit liefert",
                "Bitte beachte, dass dies eine Einzelleistung ist und eine Anpassung deines Planes nur einmal pro Zahlung möglich ist.",
                "Einzelleistungen sind ab Kaufdatum 2 Jahre gültig."
            ]
        },
        {
            id: "form-check",
            title: "Übungs-Form-Check",
            price: 79,
            content: [
                "Hierbei kannst du mir mittels aufgenommener Videodateien von dir, 4 Übungsausführungen aus deinem Training senden. Diese analysiere ich und gebe dir Feedback, wie du jene noch effektiver gestalten und ausführen kannst. Das Feedback bekommst du optimal in einem Retour-Video verpackt, welches du dir herunterladen und somit immer wieder ansehen kannst.",
                "Einzelleistungen sind ab Kaufdatum 2 Jahre gültig."
            ]
        },
        {
            id: "calls",
            title: "Consultation Calls",
            price: 0,
            content: [
                "Du hast spezifische Fragen zum Training, oder willst gezielt dein Wissen erweitern? Dann kannst du mich bei einem Consultation Call mit deinen Fragen löchern und ich werde nach bestem Wissen & Gewissen Antworten liefern. Sollte es einmal eine Frage geben, welche ich nicht sofort mit der gewünschten Qualität beantworten kann, werde ich dir eine Antwort 2-3 Werktage nach unserem Call zukommen lassen. Dies dient vor allem der Qualitätssicherung und um dir keine halbherzigen Antworten zu geben.",
                "Einzelleistungen sind ab Kaufdatum 2 Jahre gültig."
            ],
            options: [
                {
                    type: "30min",
                    cost: 109
                },
                {
                    type: "45min",
                    cost: 149
                }
            ]

        }
    ],
    packageActionsContent: [
        {
            id: "mini",
            title: "Mini Package",
            price: 249,
            content: [
                "Erstellen eines Trainingsplans",
                "1x Consulting Call 30 min zum Anpassen des Trainingsplans und weiteren trainingsspezifischen Fragen",
                "Übungs-Form-Check (4 Übungskorrekturen)",
                "",
                "Packages sind ab Kaufdatum 2 Jahre gültig."
            ]
        },
        {
            id: "maxi",
            title: "Maxi Package",
            price: 399,
            content: [
                "Erstellen eines Trainingsplans",
                "2x Consulting Calls 30 min zum Anpassen des Trainingsplans und weiteren trainingsspezifischen Fragen",
                "Übungs-Form-Check (8 Übungskorrekturen)",
                "",
                "Packages sind ab Kaufdatum 2 Jahre gültig."
            ]
        },
        {
            id: "check",
            title: "Checkup-Package",
            price: 239,
            content: [
                "Trainingsplan Checkup",
                "1x Consulting Call 30 min für Fragen zum gecheckten Trainingsplan und weiteren trainingsspezifischen Fragen",
                "Übungs-Form-Check (4 Übungskorrekturen)",
                "",
                "Packages sind ab Kaufdatum 2 Jahre gültig."
            ]
        },
        {
            id: "form",
            title: "Übungs-Form-Check-Package",
            price: 199,
            content: [
                "12 Übungs-Form-Checks",
                "",
                "Packages sind ab Kaufdatum 2 Jahre gültig."

            ],

        },
        {
            id: "cons",
            title: "Consulting-Package",
            price: 299,
            content: [
                "3x Consulting Calls 30min",
                "",
                "Packages sind ab Kaufdatum 2 Jahre gültig."
            ],

        }
    ]


}
